<template>
  <RouterView />
</template>

<script>
export default {
  name: 'App',
  mounted () {
    this.startExperiment();
  },
  methods: {
    startExperiment () {
      window.dataLayer.push({ event: 'startExperiment' });
    },
  },
};
</script>

<style lang="scss">
  @import '../node_modules/@trendyol/sc-ui-kit/styles/marketplace';
  @import "~@trendyol-js/grace/css/root";
  @import "~@trendyol-js/grace/css/system";

  h3 {
    font-size: 1.75rem;
  }

  h6 {
    font-size: 1rem;
  }

  b {
    font-weight: 500;
  }

  u {
    text-decoration: underline;
  }

  .sc-link {
    text-decoration: underline;
    color: var(--orange-500) !important;
  }

  .sc-error-message {
    font-size: 12px;
    position: absolute;
    color: var(--red-500);
    font-weight: 400;
    margin-top: 5px;
    margin-left: 10px;
  }

  .sc-bold {
    font-weight: 500 !important;
  }

  small {
    font-size: 80%;
  }

  .form-control, .btn {
    font-size: 0.875rem;
  }

  input[autocomplete=new-password] {
    padding-right: 30px;
  }

  input[autocomplete=new-password] + .eye-icon {
    transform: translateY(-50%);
    top: 50%;
  }

  a {
    &, &:hover, &:focus {
      color: #333;
    }

    text-decoration: none;
  }

  .recaptcha {
    display: flex;
    width: 100%;
    justify-content: center;
  }

  .modal-mask{
    position: fixed !important;

    .modal-dialog {
      width: unset !important;
      @media (min-width: 576px){
        min-width: 500px !important;
      }
    }
  }

</style>
